<div class="flex flex-col gap-4 pt-4" >
  <div class="flex justify-between">
    <div class="w-full md:w-20/12">
      @for (question of questions; track question) {
        <afcu-input [form]="form" [question]="question" searchQueryType="branch"/>
      }  
    </div>
  </div>
  <div class="rounded flex flex-col gap-2 md:gap-4 lg:gap-4 h-fit">
    @for (branch of branchService.items(); track branch) {
      <div class="flex flex-col gap-4">
        <afcu-list [branchInformation]="branch"  (externalFunction)="selectEvent($event)"/>
      </div>
    } 
    @empty {
      <afcu-empty-search [target]="target"/>
    }

    @if(branchService.items().length != branchService.fetchBranches().length){
      <div class="text-afcu-navy-800 font-semibold text-sm px-5 py-2.5 cursor-pointer" (click)="resetSearch()">{{textService.getText().page.clear}}</div>
    }
  </div>
</div>